module.exports = __webpack_public_path__ + "img/header06.b542f8cc.png";